// import "./product.scss";

// import { useState } from "react";
// import ChildSideColumn from "../../Components/sidebars/ChildSideColumn";
// import MainSideColumn from "../../Components/sidebars/MainSideColumn";
// import { useDispatch, useSelector } from "react-redux";
// import { PRODUCTS } from "./constant";
// import { useNavigate } from "react-router-dom";
// import { hide } from "../../redux/SideBarSlice";

// const Product = () => {
//   const [activeIndex, setActiveIndex] = useState(null);

//   const visible = useSelector((state) => state.sidebarItem.visible);
//   const source = useSelector((state) => state.sidebarItem.source);
//   const navigate = useNavigate()
//   const dispatch = useDispatch()

//   function handleProductClick(index) {
//     // setActiveIndex(index);
//     navigate(PRODUCTS[index].path);
//     dispatch(hide())
//     console.log("from product visibe", visible, "sorce", source);

//   }

//   return (
//     <>
//       {visible && source === "products" && (
//         <div className="product-container">

//           {/* Main Products Column */}
//           <MainSideColumn
//             products={PRODUCTS}
//             activeIndex={activeIndex}
//             onProductClick={handleProductClick}
//             title="Solutions"
//           />




//         </div>
//       )}
//     </>
//   );
// };

// export default Product;



import "./product.scss";
import { useState } from "react";
import ChildSideColumn from "../../Components/sidebars/ChildSideColumn";
import MainSideColumn from "../../Components/sidebars/MainSideColumn";

import { useDispatch, useSelector } from "react-redux";
import { DIRECT_CARDS, PRODUCTS } from "./constant";
import { hide } from "../../redux/SideBarSlice";
import RightContentColumn from "../../Components/sidebars/RightContentColumn ";
import { useLocation } from "react-router-dom";



const Product = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const visible = useSelector((state) => state.sidebarItem.visible);
  const source = useSelector((state) => state.sidebarItem.source);
  const dispatch = useDispatch();
  const location = useLocation();

  const getActiveCards = () => {
    if (activeIndex === null) return [];
    const activeItem = PRODUCTS[activeIndex];
    if (!activeItem) return [];

    const activeSegment = activeItem.segments?.find(
      (seg) => seg.path === location.pathname
    );

    return activeSegment?.cards || activeItem.cards || [];
  };

  return (
    <>
      {visible && source === "products" && (
        <div className="product-container">

          {/* LEFT – Main Menu */}
          <MainSideColumn
            products={PRODUCTS}
            activeIndex={activeIndex}
            onProductClick={setActiveIndex}
            title="Solutions"
          />

          {/* CENTER – Segments (only if exist) */}
          {activeIndex !== null &&
            PRODUCTS[activeIndex]?.segments?.length > 0 && (
              <ChildSideColumn
                title={PRODUCTS[activeIndex].text}
                items={PRODUCTS[activeIndex].segments}
                className="child-column"
              />
            )}

          {/* RIGHT – Cards */}
          <RightContentColumn
            cards={DIRECT_CARDS}
            // limit={activeIndex !== null && PRODUCTS[activeIndex]?.segments?.length > 0 ? 4 : null}
          />

        </div>
      )}
    </>
  );
};

export default Product;
